// Plain context object - kept in its own .ts file (no JSX, no
// component exports) so the matching ``UserProvider.tsx`` satisfies
// the ``react-refresh/only-export-components`` lint rule.
import { createContext } from "react";

import type { ViewAs } from "../api/viewAs";

import type { Role } from "./roles";

export interface UserContextValue {
  user: {
    // Kinde user id. Recorded as ``pulled_by`` on Gmail-imported
    // uploads so the Files tab can gate the Refresh action to the
    // operator who imported the thread.
    id?: string | null;
    email?: string | null;
    given_name?: string | null;
    family_name?: string | null;
  } | null;
  // Role granted by Kinde org membership; ``null`` until the
  // ``UserProvider`` gate confirms the user's org is recognised.
  // Children inside the provider can read this to render role-gated
  // UI - currently every recognised user is ``admin``, but future
  // orgs (e.g. ``landlord``, ``tenant``) will widen this union.
  role: Role | null;
  /** Staff viewing a shared page as someone on its list (View as): the app reads as
   * theirs, ``role`` is ``external``, and nothing can be written. */
  viewingAs: ViewAs | null;
  logout: (() => void) | null;
}

export const UserContext = createContext<UserContextValue>({
  user: null,
  role: null,
  viewingAs: null,
  logout: null,
});
